import React from 'react';
import { VideoItemProps } from './type';

export const ImageComponent = ({ url, width, height }: Omit<VideoItemProps, 'loop' | 'onVideoEnded' | 'muted'>) => {
    return (
        <img 
            src={url}
            alt="Escalator content"
            style={{ width, height, objectFit: 'cover' }}
            className="escalator-image-item"
        />
    );
};
